// Projectと同じだが共有しない

export const TaskStatusTypes = [
  "未着工",
  "施工前",
  "施工中",
  "施工終了",
  "保留"
] as const;

export type TaskStatus = typeof TaskStatusTypes[number];

export const TaskStatusCode: Record<TaskStatus, number> = {
  未着工: 5,
  施工前: 1,
  施工中: 2,
  施工終了: 4,
  保留: 3
};

export const TaskStatusType: Record<string, TaskStatus> = Object.entries(
  TaskStatusCode
).reduce((o, [k, v]) => {
  o[v] = k;
  return o;
}, Object.create(null));

export function getTaskStatus(statusCode: string): TaskStatus {
  const status = TaskStatusType[statusCode];
  if (status) {
    return status;
  }
  throw new Error("invalid status code");
}

export function getTaskStatusCode(status: TaskStatus): number {
  const code = TaskStatusCode[status];
  if (code) {
    return code;
  }
  throw new Error("invalid status");
}
